/*  React  */
import React from 'react';

/*  Reports  */
import Overview from './Reports/Overview';

export const BrowserReport = (props) => {
    const { reportData } = props;

    return <Overview data={reportData} />;
};
